import {
  DialogProps,
  styled,
  Dialog as MuiDialog,
  Typography,
  Box,
  alpha,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const DialogBox = styled(MuiDialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: '16px',
  },
  '& .MuiDialogActions-root': {
    padding: '16px',
  },
}));

export const DialogBoxTitleText = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  color: theme.palette.primary.main,
  fontWeight: '600',
  textTransform: 'capitalize',
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
  },
}));

export const DialogBoxCloseIcon = styled(CloseIcon)(({ theme }) => ({
  height: '20px',
  width: '20px',
  color: alpha(theme.palette.primary.main, 0.69),
  fontWeight: '600',
  [theme.breakpoints.up('md')]: {
    height: '28px',
    width: '28px',
  },
}));

export const Dialog = styled(MuiDialog)<DialogProps>(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '20px',
    padding: '32px',
    gap: '18px',
    maxWidth: '501px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '24px',
      gap: '24px',
      margin: '24px',
    },
  },
}));

export const DialogTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '24px',
  fontWeight: '600',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
}));

export const DialogSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '400',
  [theme.breakpoints.down('md')]: {
    fontSize: '14px',
  },
}));

export const DialogHeader = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
});
